export const PARAGRAPH_Y_OFFSET = 5;
export const LINE_HEIGHT_FACTOR = 1.5715;
export const LINE_HEIGHT_SCALE = 1.5715;
export const FONT_SIZE_SCALE = 0.992;
export const TEXT_WIDTH_SCALE = 0.988;
export const BULLET_SPACE_SCALE = 1;
export const LIST_ITEM_SYMBOL_X_OFFSET = -28;
export const LIST_ITEM_SPACE_SCALE = 1.45;
export const EMOJI_WIDTH_SCALE = 1;
export const EMOJI_SPACING_SCALE = 1.025;
export const LOGO_WIDTH = 230;
export const SMALL_LOGO_WIDTH = 100;
export const LOGO_HEIGHT = 130;
export const SMALL_LOGO_HEIGHT = 50;
export const LOGO_MARGIN = 30;
export const SVG_IMAGE_ZOOM = 4;
export const POLL_Y_POSITION_RATIO = 0.78;
export const POLL_OPTION_PADDING_RATIO = 0.05;
export const POLL_OPTION_GAP = 30;
export const POLL_BAR_Y_OFFSET = 43;
